// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "checkout-bankredirect" + "." + "5b164cbf6b86c2f6ab1c" + ".css";
};